import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading } from "components/misc/Headings.js";
import productsMockupSrc from "images/products-mockup.png";

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-6/12 lg:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)(props => [
  tw`md:w-6/12 mt-8 md:mt-0`,
  props.textOnLeft ? tw`md:mr-8 lg:mr-16 md:order-first` : tw`md:ml-8 lg:ml-16 md:order-last`
]);

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8`;

const Heading = tw(SectionHeading)`text-left text-3xl sm:text-4xl lg:text-4xl text-center md:text-left leading-tight`;
const Description = tw.p`text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100 mt-4`

const Products = tw.div`mt-6 lg:mt-8 xl:mt-16 flex flex-wrap items-baseline justify-center md:justify-start text-lg sm:text-2xl lg:text-3xl`
const ProductName = tw.span`font-bold text-primary-500`
const Separator = tw.span`mx-3 text-gray-400`

export default ({textOnLeft = false}) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  const products = ["Lumi", "Final Account", "PaperLink"]

  return (
    <Container>
      <TwoColumn>
        <ImageColumn>
          <Image imageSrc={productsMockupSrc} />
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            <Heading>Why businesses choose us.</Heading>
            <Description>We don’t just build software and walk away. Every product we create is used by real people, every day, so we design for reliability first. We listen closely, keep things simple, and stay with our clients long after launch, because your success is how we measure ours.</Description>
            <Products>
              {products.map((name, index) => (
                <React.Fragment key={name}>
                  {index > 0 && <Separator>·</Separator>}
                  <ProductName>{name}</ProductName>
                </React.Fragment>
              ))}
            </Products>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
